/** Пункт меню или группа */
export type MenuItemNode = {
  id?: string
  url?: string
  type?: string
  children?: MenuItemNode[]
}

const MANAGER_ALLOWED_MENU_IDS = new Set(['analytic', 'customers'])

/**
 * Оставляет в меню только пункты, доступные роли.
 * @param menuItems — дерево menu-items
 * @param isManager — текущий пользователь менеджер
 */
export const filterMenuItemsByRole = <MenuNode extends MenuItemNode>(
  menuItems: MenuNode[],
  isManager: boolean
): MenuNode[] => {
  if (!isManager) {
    return menuItems
  }

  return menuItems
    .map(groupItem => {
      const children = (groupItem?.children ?? []).filter(childItem =>
        MANAGER_ALLOWED_MENU_IDS.has(childItem?.id ?? '')
      )
      return { ...groupItem, children }
    })
    .filter(groupItem => (groupItem?.children?.length ?? 0) > 0)
}
